var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    [
      _c("b-col", { attrs: { cols: "12" } }, [
        _vm._v(
          "\n    " +
            _vm._s(_vm.$t("settings.accountTab.syncInfoFromExpertMsg")) +
            "\n  "
        ),
      ]),
      _vm._v(" "),
      _c("b-col", { attrs: { cols: "6" } }, [
        _c(
          "ul",
          { staticClass: "my-2 pl-2 text-left" },
          _vm._l(_vm.expertDetails("lender"), function (detail) {
            return _c(
              "li",
              {
                key: "expert-detail-" + detail,
                staticClass: "text-capitalize mb-1",
              },
              [
                _c("icon", {
                  attrs: {
                    name: "check-circle",
                    "icon-class": "text-primary mr-1",
                  },
                }),
                _vm._v("\n        " + _vm._s(detail) + "\n      "),
              ],
              1
            )
          }),
          0
        ),
      ]),
      _vm._v(" "),
      _c("b-col", { attrs: { cols: "6" } }, [
        _c(
          "ul",
          { staticClass: "my-2 pl-2 text-left" },
          _vm._l(_vm.expertDetails("personal"), function (detail) {
            return _c(
              "li",
              {
                key: "expert-detail-" + detail,
                staticClass: "text-capitalize mb-1",
              },
              [
                _c("icon", {
                  attrs: {
                    name: "check-circle",
                    "icon-class": "text-primary mr-1",
                  },
                }),
                _vm._v("\n        " + _vm._s(detail) + "\n      "),
              ],
              1
            )
          }),
          0
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }